<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Geqc5e/tc-custom/9780226223230.jpg?1722573301119" alt="This image is the cover for the book Moral Imagination"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moral Imagination
      </h1>
      <p class="bookDescription body article font2">
        <p>Using path-breaking discoveries of cognitive science, Mark Johnson argues that humans are fundamentally imaginative moral animals, challenging the view that morality is simply a system of universal laws dictated by reason. According to the Western moral tradition, we make ethical decisions by applying universal laws to concrete situations. But Johnson shows how research in cognitive science undermines this view and reveals that imagination has an essential role in ethical deliberation.<br/><br/> Expanding his innovative studies of human reason in <i>Metaphors We Live By</i> and <i>The Body in the Mind,</i> Johnson provides the tools for more practical, realistic, and constructive moral reflection.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Johnson
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?149842fe